import React from 'react'
import { Link } from 'gatsby'
import { StaticQuery, graphql } from 'gatsby'
// import VisibilitySensor from 'react-visibility-sensor'
import NavLinks from './NavLinks'

export const ParentHead = ({ path, data: { allMarkdownRemark: { edges: [{ node: { frontmatter: { title, logo, navlink } } }] } } }) => {
  // const onChange = (isVisible) => {
  //   const element = document.getElementById("navbar");
  //   if (!isVisible) {
  //     element.classList.add("box-shadow-navbar");
  //     element.classList.remove("border-bottom");
  //   } else {
  //     element.classList.add("border-bottom");
  //     element.classList.remove("box-shadow-navbar");
  //   }
  // }
  return (
    // <VisibilitySensor onChange={onChange}>
    <div>
      <header className="header">
        <div className="header-inner">
          <nav className="navbar navbar-expand-lg fixed-top border-color-light-gray bg-white p-0" id="navbar">
            <div className="container p-0">
              <Link className="navbar-brand logo md-font-size text-dark-gray m-0" to="/">
                <img src={`${logo ? logo : '/img/pirlo-logo-1.png'}`} className="logo-img" alt="Create and run automated mobile test in less than 30 minutes! | Pirlo" title="Create and run automated mobile test in less than 30 minutes! | Pirlo" />
              </Link>
              <button className="navbar-toggler base-plus-font-size collapsed" type="button" data-toggle="collapse" data-target="#main-menu" aria-controls="main-menu" aria-expanded="false" aria-label="Toggle navigation">
                <span className="base-color fas fa-bars xl-font-size"></span>
              </button>
              <div className="collapse navbar-collapse mt-3 mt-lg-0 sm-font-size" id="main-menu">
                <ul className="navbar-nav ml-auto">
                  <NavLinks navlink={navlink} path={path}/>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </div>
    // </VisibilitySensor>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
    query HeadingQuery {
      allMarkdownRemark(
        filter: { frontmatter: { templateKey: { eq: "header-block" } }}
      ) {
        edges {
          node {
            frontmatter {
              title
              logo
              navlink{
                title
                url
                visible
                hashValue
                externalLink
                highlight
                target
              }
            }
          }
        }
      }
    }
    `}
    render={data => <ParentHead data={data} {...props} />}
  />
)
